import { render, staticRenderFns } from "./LogosColor.vue?vue&type=template&id=1c36a530&"
import script from "./LogosColor.vue?vue&type=script&lang=js&"
export * from "./LogosColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports